import { ApiCountryKey } from '../types/apiCountryKey'

const map: Record<string, ApiCountryKey> = {
  NL: 'nl',
  FR: 'fr',
}

/* This endpoint is only used for ML Booky tags suggestions and company cvr search */
/* For most countries we default to DK because those API only support specific countries */
export const getApiCountryKey = (countryId?: string, language?: string): ApiCountryKey => {
  if (countryId) {
    return map[countryId] || 'dk'
  }

  return (language === 'fr' && 'fr') || (language === 'nl' && 'nl') || 'dk'
}
